import * as MenuPrimitive from '@radix-ui/react-dropdown-menu';
import { useTranslation } from 'react-i18next';
import { WorkspaceIcon } from '@/components/workspace/WorkspaceIcon';
import { useLanguageStore } from '@/stores/language';
import { isLanguage } from '@/utils/language';
import { LANGUAGES } from './languages';

/**
 * Языки пунктами выпадающего меню пользователя: язык интерфейса выбирается здесь.
 * Пункты меню, а не кнопки: Radix ожидает в содержимом меню свои Item, и
 * вложенная кнопка ломает клавиатурную навигацию по пунктам. Пункты -- выбор
 * одного из двух: активный язык отмечен. Своих классов у пунктов нет: вид
 * задаёт меню, в котором они стоят (training-menu макета).
 */
export function LanguageMenuItems() {
	const { t } = useTranslation('common');
	const language = useLanguageStore((s) => s.language);
	const setLanguage = useLanguageStore((s) => s.setLanguage);

	return (
		<MenuPrimitive.RadioGroup
			value={language}
			onValueChange={(value) => {
				if (isLanguage(value)) setLanguage(value);
			}}
		>
			{LANGUAGES.map(({ code, Flag, labelKey }) => (
				<MenuPrimitive.RadioItem key={code} value={code}>
					<Flag size={16} />
					{t(labelKey)}
					<MenuPrimitive.ItemIndicator className="ws-menu-indicator">
						<WorkspaceIcon name="check" size={14} />
					</MenuPrimitive.ItemIndicator>
				</MenuPrimitive.RadioItem>
			))}
		</MenuPrimitive.RadioGroup>
	);
}
